var _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeploySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#A4BB0B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "url(#pattern0_13251_46024)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_13251_46024",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13251_46024",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13251_46024",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAAB/klEQVRYhcWWP2sUQRjGnxwJiIIuggjaXCNYXmNjdYUf4JrUsbWzsd/SSrayvo+w4BeIX0AujWBl8g02KIEQkp/FzZzvze3szK4b88ALO7PDPs/7d3YP0F1i/z/xFJJm7nklqdm8AW7DpkAFrGhH6c+OTVwAywhpCAGjpmAm6VjSI7c+l7R0e40J/XbRjeT5DGiCEBeRCG1FYGzyxq1jZ+ehgMmIYT+XNHehjqEIN7pqwLZO7P2yB7ncGUk62exk5rQLqbDb/PtvVl01UBDv36HkYl2YHtMuAbU5uMj8eE6heiztuy6V5Yjktku22tMeXBjy+pbId9K1B5vB1OjvFDuRdCrpq6Tvkn5KOpN0mahyi7wWNWqO2cY18AP4AnwC3gFvgKfGuyr0KNdzb3YOLJzqqbOXkn5JeijpwtiNduf++8CvtOctEeiye8AT4DHwKsM7j2SLdhVPze6Fkhtaj6RzqfzVkf3UABosIEYS23/AOjWjCOhLft89vwb2/1VAX3IBB8AhcAQ8Gypg0jEwUoPkStILZ8+jbZbARFI5gNzjxojwWPRSwLrV6iC8VSQdYWt+BL4Bn926NOFv+tRAm1WRWrCt+QH47UTYa3xFxhBKCcjp/7fsom2ADRaQGj7zgLzMJc4V4MMam3wF61v0lIF/T6kDbQU6qtkfkjvBH8n6ICeOIoPVAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploySearch);
export default __webpack_public_path__ + "static/media/deploy_search.7fa66a90901a4300fd095c70875fc3f3.svg";
export { ForwardRef as ReactComponent };